import { useTranslation } from 'react-i18next';
import SwitchRow from './SwitchRow.tsx';
import classnames from '../utils/classnames.tsx';

interface ToggleListProps {
    value: string[];
    onValueChange: (value: string[]) => void;
    onBlur?: (event: any) => void;
    items: string[];
    translationPrefix: string;
    requiredItems?: string[];
    disabledItems?: string[];
    disabled?: boolean;
    className?: string;
}

const ToggleList = ({
    value,
    onValueChange,
    onBlur,
    className,
    items,
    translationPrefix,
    requiredItems = [],
    disabledItems = [],
    disabled = false,
}: ToggleListProps) => {
    const { t } = useTranslation('config');

    const addItem = (name: string) => {
        onValueChange([...value, name]);
    };

    const removeItem = (name: string) => {
        onValueChange(value?.filter((item) => item !== name) || []);
    };

    const handleToggleSwitch = (name: string, checked: boolean) => {
        if (checked) {
            addItem(name);
        } else {
            removeItem(name);
        }
        onBlur?.(null);
    };

    return (
        <div className={classnames('flex flex-col', className)}>
            {items.map((name) => (
                <SwitchRow
                    key={name}
                    label={t(`${translationPrefix}.${name}`)}
                    value={value?.includes(name) || requiredItems.includes(name)}
                    onValueChange={(checked) => handleToggleSwitch(name, checked)}
                    disabled={disabled || requiredItems.includes(name) || disabledItems.includes(name)}
                />
            ))}
        </div>
    );
};

export default ToggleList;
